<!-- eslint-disable vue/html-indent -->
<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div class="main_control">
    <div class="control" :style="getStyle('清除')" @click="qingChu()">清除</div>
    <div class="control" :style="getStyle('测距')" @click="ceJu()">测距</div>
    <div class="control" :style="getStyle('测面')" @click="ceMian()">测面</div>
    <!-- <div class="control" :style="getStyle('框选查询')" @click="kuangXuan()" v-if="enableFrameQuery">框选查询</div> -->
    <div class="control" :style="getStyle('多边查询')" @click="DuoBianXing()" v-if="enableFrameQuery">多边查询</div>
    <div class="control" :style="getStyle('多边删除')" @click="duoBiandeleteLine()" v-if="enableFrameQuery">多边删除</div>
    <!-- <div class="control" :style="getStyle('单选删除')" @click="deleteLine()" v-if="enableFrameQuery">单选删除</div> -->
  </div>
</template>

<script>
import DragBox from 'ol/interaction/DragBox'
import Select from 'ol/interaction/Select'
import { Modify, Snap, Draw } from 'ol/interaction'
import measure from './measure.js'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Feature from 'ol/Feature'
import Polygon from 'ol/geom/Polygon'
import Stroke from 'ol/style/Stroke'
import Fill from 'ol/style/Fill'
import Point from 'ol/geom/Point'
import Style from 'ol/style/Style'
export default {
  props: {
    enableFrameQuery: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      value: true,
      parentMap: null,
      textColor: { color: '#1A98FD' },
      textColor1: { color: '#095b8e' },
      removeIcon: require('@/assets/myImg/1/icon-清除.png'),
      rangingIcon: require('@/assets/myImg/1/icon-测距.png'),
      measuringIcon: require('@/assets/myImg/1/icon-测面.png'),
      deleteUrl: '/pipe-network/gis/pipe-networks/region/statistics/delete',
      isActive: '',
    }
  },
  mounted () {
    this.vectorSource = new VectorSource()
    this.vectorLayer = new VectorLayer({
      source: this.vectorSource,
      style: new Style({
        fill: new Fill({
          // 填充样式
          color: 'rgba(0,255,255, 0.0)'
        }),
        stroke: new Stroke({
          // 线样式
          color: '#2F4F4F',
          width: 3
        })
      })
    })
    this.vectorLayer.set('kxcx_layer', this.vectorLayer)
    this.$nextTick(() => {
      this.parentMap = this.$parent.getBigMap()
    })
  },
  methods: {
    deleteLayer (str) {
      var layer = this.parentMap.getLayers().getArray().find(function (layer) {
        return layer.get('id') === str
      })
      if (layer) {
        this.parentMap.removeLayer(layer)
      }
    },
    getStyle (str) {
      if (this.isActive === str) {
        return { background: 'rgba(0, 32, 54,1)' }
      }
    },
    hideControl () {
      console.log(123)
      this.$emit('hideControl', null)
    },
    qingChu () {
      this.isActive = '清除'
      this.deleteLayer('dbxcx_layer')
      // id: 'helpTooltip',
      console.log('getOverlays', this.parentMap.getOverlays())
      var helpTooltipOverlays = this.parentMap.getOverlays().array_
      var listLayers = this.parentMap.getLayers().array_
      for (var ii = 0; ii < helpTooltipOverlays.length; ii++) {
        if (helpTooltipOverlays[ii].id === 'helpTooltip') {
          this.parentMap.removeOverlay(helpTooltipOverlays[ii])
          ii-- // 如果不减，将漏掉一个元素
        }
      }
      for (var i = 0; i < listLayers.length; i++) {
        if (listLayers[i].values_.name === 'helpTooltip') {
          listLayers.splice(i, 1) // 将使后面的元素依次前移，数组长度减1
          i-- // 如果不减，将漏掉一个元素
        }
      }
      this.parentMap.render()
      this.removeLicen()
    },
    ceJu () {
      this.isActive = '测距'
      this.removeLicen()
      measure.measure(this.parentMap, 'LineString')
      this.cjimg = require('@/assets/myImg/1/h_0_fmj.png')
    },
    ceMian () {
      this.isActive = '测面'
      this.removeLicen()
      measure.measure(this.parentMap, 'Polygon')
      this.cmimg = require('@/assets/myImg/1/h_0_fmj.png')
    },
    removeLicen () {
      var mapLicen = this.parentMap.getInteractions().array_
      mapLicen.forEach(item => {
        if (item.constructor.name === 'Draw' || item.constructor.name === 'DragBox') { this.parentMap.removeInteraction(item) }
      })
    },
    clearMap () {
      this.vectorSource.clear()
    },
    renderArea (data) {
      var map = this.parentMap
      // 创建要素
      // 使用多边形类型
      const features = [new Feature({ geometry: new Polygon([data]) })]
      // 创建矢量数据源
      const source = new VectorSource({ features })
      // 创建样式
      const style = new Style({
        stroke: new Stroke({
          color: '#4C99F8',
          width: 3,
          lineDash: [5]
        }),
        fill: new Fill({ color: 'rgba(255,255,255,0.1)' })
      })
      // 创建矢量图层
      const areaLayer = new VectorLayer({ source, style, zIndex: 1 })
      // 添加到地图实例
      map.addLayer(areaLayer)
    },
    deleteLine () {
      console.log('删除线条')
    },
    duoBiandeleteLine () {
      this.isActive = '多边删除'
      const map = this.parentMap
      const source = new VectorSource()
      this.deleteLayer('dbxcx_layer')
      this.vectorLayer = new VectorLayer({
        id: 'dbxcx_layer',
        zIndex: 99999,
        source: source,
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)'
          }),
          stroke: new Stroke({ color: '#ff0000', width: 3 })
        })
      })
      const modify = new Modify({ source: source })
      const snap = new Snap({ source: source })
      const draw = new Draw({ source: source, type: 'Polygon' })
      // projection: 'EPSG:4490',
      map.addInteraction(modify)
      map.addInteraction(draw)
      map.addInteraction(snap)
      map.addLayer(this.vectorLayer)
      draw.on('drawend', e => { // 绘画完成触发时间
        const geometry = e.feature.getGeometry()
        const polygon = geometry.getCoordinates()[0] || []
        map.removeInteraction(draw) // 移除交互
        map.removeInteraction(snap) // 移除交互
        map.removeInteraction(modify) // 移除交互
        this.showDeleteConfirm(polygon)
      })

    },
    showDeleteConfirm (polygon) {
      let that = this
      this.$confirm({
        title: '温馨提示',
        content: '确定要删除此区域内的管点,物探点信息?',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: async () => {
          console.log('OK');
          try {
            const result = await that.deleteClick(polygon)
            console.log(result);
          } catch (error) {
            console.error('异步操作失败', error);
            // 如果需要，可以在这里阻止对话框关闭或显示错误信息  
          }
        },
        onCancel () {
          console.log('Cancel');
          that.qingChu()
        },
      });
    },
    async deleteClick (polygon) {
      let that = this
      let map = this.parentMap
      const params = {
        linestring: polygon
      }
      try {
        const res = await this.axios.post(this.deleteUrl, params)
        console.log(res.code);
        if (res.code == 0) {
          console.log(res.data);
          this.$message.success('删除成功');
          this.qingChu();
          map.getView().setZoom(map.getView().getZoom() + 0.01);
          return res.data; // 直接返回结果  
        } else {
          throw new Error(res.message); // 抛出错误，而不是返回一个被 reject 的 Promise  
        }
      } catch (error) {
        // 如果 axios 请求失败或其他错误，则直接抛出  
        throw error;
      }
    },
    DuoBianXing () {
      this.isActive = '多边查询'
      const map = this.parentMap
      const source = new VectorSource()
      this.deleteLayer('dbxcx_layer')
      this.vectorLayer = new VectorLayer({
        id: 'dbxcx_layer',
        zIndex: 99999,
        source: source,
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)'
          }),
          stroke: new Stroke({ color: '#ff0000', width: 3 })
        })
      })
      const modify = new Modify({ source: source })
      const snap = new Snap({ source: source })
      const draw = new Draw({ source: source, type: 'Polygon' })
      // projection: 'EPSG:4490',
      map.addInteraction(modify)
      map.addInteraction(draw)
      map.addInteraction(snap)
      map.addLayer(this.vectorLayer)
      draw.on('drawend', e => { // 绘画完成触发时间
        const geometry = e.feature.getGeometry()
        const polygon = geometry.getCoordinates()[0] || []
        this.$emit('kuangXuan', polygon)
        map.removeInteraction(draw) // 移除交互
        map.removeInteraction(snap) // 移除交互
        map.removeInteraction(modify) // 移除交互
      })
    },
    kuangXuan () {
      // this.hideControl()
      this.isActive = '框选查询'
      this.removeLicen()
      var that = this
      var map = this.parentMap
      map.removeLayer(this.vectorLayer)
      var boxSelect = new Select()
      console.log('boxSelect=====', boxSelect)
      var selectedFeatures = boxSelect.getFeatures()
      console.log('selectedFeatures=====', selectedFeatures)
      // 拉框，用于划定一个矩形范围
      var dragBox = new DragBox({})
      console.log('dragBox=====', dragBox)
      map.addInteraction(dragBox)
      map.addLayer(this.vectorLayer)
      // boxdrag 拖拽时
      // boxend 拖拽结束
      // boxstart 开始拖拽
      dragBox.on('boxend', function () {
        console.log('boxend=====拖放结束')
        var geo = dragBox.getGeometry()
        console.log('geo=====', geo)
        var polygon = geo.getCoordinates()[0]
        console.log('polygon=====', polygon)
        const featureobj = new Feature({ geometry: dragBox.getGeometry() })
        console.log('featureobj=====', featureobj)
        that.vectorSource.addFeature(featureobj)
        this.isActive = ''
        that.$emit('kuangXuan', polygon)
        map.removeInteraction(dragBox)
      })
      dragBox.on('boxstart', function () {
        console.log('boxstart=====开始拖拽')
        selectedFeatures.clear()
        that.vectorSource.clear()
      })
    }
  }
}
</script>

<style>
.main_control {
  width: 60px;
  z-index: 1;
}

.control {
  background: rgba(0, 32, 54, 0.75);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  width: 60px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
  color: #ffffff;
  border-radius: 3px;
  cursor: pointer;
}

.ol-tooltip {
  width: 200px;
  height: 40px;
  line-height: 40px;
  color: green;
  text-align: center;
  font-size: 20px;
}
</style>
